import { InsertionPoint } from './insertion-point';

export class InteractiveInsertionPoint<TNeighbor = unknown> extends InsertionPoint<TNeighbor> {}
